import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}/admin`
const baseUrl2 = `${process.env.REACT_APP_BACKEND_HOST}/v2/admin`

const crmFailList = async (userId) => {
  const res = await axios.get(`${baseUrl}/crm/list/fail`, {
    headers: {
      userId: userId,
    },
  })
  return res
}

const searchCrmHistoryList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/crm/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const changeCRMListToWait = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/crm/list/change/wait`, param, {
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 회원 목록 조회
 * @param param
 * @param userId
 */
const readCustomerList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/user/list`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 회원 포인트 내역 조회
 * @param
 * @param userId
 */
const readMemberPointHistoryList = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/user-point/history`, {
    params: param,
    headers: {
      adminId: userId,
    },
  })
  return res
}

/**
 * 회원 포인트 발급하기
 * @param param
 */
const earnPointForMember = async (param) => {
  const res = await axios.post(`${baseUrl}/point/give`, param)
  return res
}

const readAllUserListForSMS = async (param, userId) => {
  const res = await axios.get(`${baseUrl}/user/list/sms-target`, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

const createGuestUser = async (param, userId) => {
  const res = await axios.post(`${baseUrl}/user-join`, param, {
    params: param,
    headers: {
      userId: userId,
    },
  })
  return res
}

/**
 * 카카오 템플릿 (이벤트) 조회
 */
const readKakaoTemplateList = async ({
  page = 0,
  size = 10,
  // sort = 'createdAt,asc',
}) => {
  try {
    const res = await axios.get(`${baseUrl2}/kakao-template`, {
      params: {
        category: 'EVENT',
        page,
        size,
      },
    })
    return res
  } catch (error) {
    console.error('readKakaoTemplateList err', error)
    return null
  }
}

const customerApi = {
  crmFailList,
  searchCrmHistoryList,
  changeCRMListToWait,
  readCustomerList,
  readMemberPointHistoryList,
  earnPointForMember,
  readAllUserListForSMS,

  createGuestUser,
  readKakaoTemplateList,
}

export default customerApi
